import PropTypes from 'prop-types'
import React, { useEffect, useRef, useCallback } from 'react'

//Import Icons
import Icon from '@ailibs/feather-react-ts'

// //Import Scrollbar
import SimpleBar from 'simplebar-react'

//i18n
import { withTranslation } from 'react-i18next'

//redux
import { useSelector, useDispatch } from 'react-redux'

// MetisMenu
import MetisMenu from 'metismenujs'
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'
import UserProfileResponse from '../../api-dtos/profile/user-profile-response.dto.interface'
import { fetchProfile } from '../../store/actions'
import { fetchSupportProfile } from '../../store/auth/profile-support/actions'
import {
  isSupportUserAuthenticated,
  isUserAuthenticated,
} from '../../helpers/lopay_api_helper'

const SidebarContent = (props: any) => {
  const dispatch = useDispatch()
  const ref = useRef<any>()

  const { profile } = useSelector(
    (state: { profile: { profile: UserProfileResponse } }) => ({
      profile: state.profile.profile,
    }),
  )

  useEffect(() => {
    if (isUserAuthenticated()) {
      dispatch(fetchProfile())
    }
    if (isSupportUserAuthenticated()) {
      dispatch(fetchSupportProfile())
    }
    // eslint-disable-next-line
  }, [])

  const activateParentDropdown = useCallback((item) => {
    item.classList.add('active')
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show')
    }

    if (parent) {
      parent.classList.add('mm-active')
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add('mm-show') // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add('mm-active') // li
          parent3.childNodes[0].classList.add('mm-active') //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add('mm-show') // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add('mm-show') // li
              parent5.childNodes[0].classList.add('mm-active') // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  // Use ComponentDidMount and ComponentDidUpdate method simultaneously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu('#side-menu')
      let matchingMenuItem = null
      const ul: any = document.getElementById('side-menu')
      const items = ul.getElementsByTagName('a')
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const hasMerchant: boolean =
    !!profile?.user?.merchants?.length && !!profile.user.merchants[0].id

  const hasCompletedKYC: boolean =
    hasMerchant &&
    profile.user.merchants[0].kycStatus.restrictions === undefined

  const hasCompletedPayouts: boolean =
    hasMerchant && profile.user.merchants[0].kycStatus.hasPayoutMethod

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: '100%' }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {profile && (
              <>
                <li>
                  {hasMerchant ? (
                    <Link to="/dashboard" className="">
                      <Icon name="home" />
                      <span>{props.t(profile.user.merchants[0].name)}</span>
                    </Link>
                  ) : (
                    <Link to="/setup-merchant" className="">
                      <Icon name="home" />
                      <span>{props.t('Setup')}</span>
                    </Link>
                  )}
                </li>

                <li className="menu-title">{props.t('Payments')}</li>

                <li>
                  <Link to="/payment-links" className="">
                    <Icon name="zap" />
                    <span>{props.t('Payment links')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/transactions" className="">
                    <Icon name="list" />
                    <span>{props.t('Payment history')}</span>
                  </Link>
                </li>

                <li className="menu-title">{props.t('Configuration')}</li>

                <li>
                  <Link to="/pay-points" className="">
                    <Icon name="smartphone" />
                    <span>{props.t('Pay points')}</span>
                  </Link>
                </li>

                {!hasCompletedKYC && (
                  <li>
                    <Link to="/kyc" className="text-danger">
                      <Icon name="alert-triangle" color="#e83e8c" />
                      <span>{props.t('Verify business')}</span>
                    </Link>
                  </li>
                )}

                {!hasCompletedPayouts && (
                  <li>
                    <Link to="/add-external-account" className="text-danger">
                      <Icon name="alert-triangle" color="#e83e8c" />
                      <span>{props.t('Add bank account')}</span>
                    </Link>
                  </li>
                )}

                {hasCompletedPayouts && (
                  <li>
                    <Link to="/external-accounts" className="">
                      <Icon name="dollar-sign" />
                      <span>{props.t('Banking & Payouts')}</span>
                    </Link>
                  </li>
                )}
              </>
            )}

            {isSupportUserAuthenticated() && (
              <>
                <li className="menu-title">{props.t('Admin & Support')}</li>

                <li>
                  <Link to="/registered-merchants" className="">
                    <Icon name="home" />
                    <span>{props.t('Merchants')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/users" className="">
                    <Icon name="user" />
                    <span>{props.t('Users')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/offers" className="">
                    <Icon name="award" />
                    <span>{props.t('Offers')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/discount-codes" className="">
                    <Icon name="gift" />
                    <span>{props.t('Discount codes')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/terminal-shipping" className="">
                    <Icon name="smartphone" />
                    <span>{props.t('Card Readers')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/app-builds" className="">
                    <Icon name="box" />
                    <span>{props.t('App builds')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <Icon name="shield" />
                    <span>{props.t('Fraud Prevention')}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/fraud-prevention/fraud-rules">
                        {props.t('Fraud Rules')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/fraud-prevention/kyb-thresholds">
                        {props.t('KYB Thresholds')}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/marketing-deep-links" className="">
                    <Icon name="list" />
                    <span>{props.t('Marketing deep links')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/waiting-lists" className="">
                    <Icon name="list" />
                    <span>{props.t('Waiting Lists')}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/hardware" className="">
                    <Icon name="smartphone" />
                    <span>{props.t('Hardware')}</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withTranslation()(withRouter(SidebarContent))
